import React from 'react'
import type { CellProps } from 'react-table'
import LinkCell from '../../Generics/GenericLinkCell'
import type { SearchVehicle } from '../types'

export const Account = ({
    row: {
        original: { consignorId },
    },
    cell: { value },
}: CellProps<SearchVehicle>): React.ReactNode =>
    consignorId && <LinkCell href={`/details/companies?id=${consignorId}`}>{value}</LinkCell>
